<template>
    <div class="cart">
        <div id="shopping-cart">
            <div class="container-fluid gray">
                <div class="container">
                    <Page-Header />
                </div>
            </div>
        </div>
        <div class="container-fluid toprow">
            <div class="container">
                <div id="cartMain" class="row">
                    <div class="col-lg-4 col-lg-push-8 col-md-4 col-md-push-8 col-sm-12 col-xs-12">
                        <Cart-Right />
                    </div>
                    <div class="col-lg-8 col-lg-pull-4 col-md-8 col-md-pull-4 col-sm-12 col-xs-12">
                        <cart-order-box :cart-item-index="Number(this.$route.params.id)"></cart-order-box>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CartOrderBox from '../components/CartOrderBox.vue'
import PageHeader from '../components/PageHeader.vue';
import CartRight from '../components/CartRight.vue';


export default {
  name: 'EditCartItem',
  components: {
    CartOrderBox,
    PageHeader,
    CartRight
  }
}
</script>
